import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import DateTime from 'react-datetime';
import * as moment from 'moment';

class BillingGroupForm extends React.Component {

  renderField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <input
          {...input}
          className="form-control"
          placeholder={label}
          type={type}
          disabled={disabled}
          maxLength={maxLength}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderDateField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-10">
          <DateTime
            // dateFormat="YYYY-MM-DD"
            timeFormat={true}
            viewDate={input.value}
            {...input}
            renderInput={(props, openCalendar, closeCalendar) => {
              const value =
                props.value && moment(props.value)
                  ? moment(props.value).format('MM/DD/YYYY')
                  : moment().format('MM/DD/YYYY');
              return (
                <div className="input-group">
                  <input {...props} type="hidden" />
                  <input
                    className="form-control"
                    type="text"
                    value={value}
                    readOnly
                    onFocus={openCalendar}
                  />
                  <span className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar" />
                  </span>
                </div>
              );
            }}
            renderDay={(props, currentDate, selectedDate) => {
              return <td {...props}>{currentDate.date()}</td>;
            }}
            onChange={param => {
              if (param) {
                // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
                input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
                // input.onChange(param)
              }
            }}
            disabled={disabled}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
    );

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
    } = this.props;
    
    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Billing Group Information</legend>
          <Field
            className="form-control"
            name="billingClientId"
            component={this.renderField}
            type="text"
            label="Billing ClientId"
            disabled={true}
            maxLength={5}
          />
          <Field
            className="form-control"
            name="billingGroup"
            component={this.renderField}
            type="text"
            placeholder="BillingGroup"
            label="BillingGroup"
          />
          <Field
            className="form-control"
            name="startDate"
            component={this.renderDateField}
            type="text"
            placeholder="StartDate"
            label="StartDate"
          />
          <Field
            className="form-control"
            name="timeToPay"
            component={this.renderField}
            type="text"
            placeholder="TimeToPay"
            label="TimeToPay"
          />
          <Field
            className="form-control"
            name="description"
            component={this.renderField}
            type="text"
            placeholder="Description"
            label="Description"
          />
          <Field
            className="form-control"
            name="contractLength"
            component={this.renderField}
            type="text"
            placeholder="ContractLength"
            label="ContractLength"
          />
        </fieldset>
        <fieldset>
          <div className="form-group">
            <label className="col-md-2 control-label">VI Shared</label>
            <div className="col-md-10">
              <div className="checkbox">
                <label>
                  <Field name="isVIShared" component="input" type="checkbox" />
                </label>
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="col-md-2 control-label">Active</label>
            <div className="col-md-10">
              <div className="checkbox">
                <label>
                  <Field name="isActive" component="input" type="checkbox" />
                </label>
              </div>
            </div>
          </div>
        </fieldset>
        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              {/* <button className="btn btn-default" type="button" disabled={pristine || submitting} onClick={reset}>
                Reset</button>{" "} */}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
        
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  if (!values.billingGroup) {
    errors.billingGroup = 'Required';
  }
  if (!values.startDate) {
    errors.startDate = 'Required';
  }
  if (!values.timeToPay) {
    errors.timeToPay = 'Required';
  }
  if (!values.description) {
    errors.description = 'Required';
  }
  return errors;
};

BillingGroupForm = connect(state => ({
  formValues: getFormValues('billingGroup')(state),
  initialValues: state.billingmanager.billingGroup,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'billingGroup' })(BillingGroupForm));
export default BillingGroupForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/BillingGroupForm.js